import { updateProject } from '@lib/api'
import { adminProjectsKeys } from '@lib/keys'
import { useMutation, useQueryClient } from '@tanstack/react-query'

export const useUpdateProject = () => {
  const queryClient = useQueryClient()

  return useMutation(
    ({ id, name }: { id: number; name: string }) => updateProject(id, name),
    {
      onSuccess: () => {
        void queryClient.invalidateQueries(adminProjectsKeys.all)
      },
    },
  )
}
